var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9 13c2.757 0 5 2.243 5 5v2a1 1 0 1 1-2 0v-2c0-1.654-1.346-3-3-3H4a1 1 0 1 1 0-2Zm7 0c2.757 0 5 2.243 5 5v2a1 1 0 1 1-2 0v-2c0-1.654-1.346-3-3-3a1 1 0 1 1 0-2M7 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8m7 0c2.206 0 4 1.794 4 4s-1.794 4-4 4a1 1 0 1 1 0-2c1.103 0 2-.897 2-2s-.897-2-2-2a1 1 0 1 1 0-2M7 5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2"
})));
export default SvgGemUsers;